import styled from 'styled-components'
import { AttendanceMonthlyCard, AttendanceOption, AttendanceOptionsWrapper, AttendanceWeeklyCard } from 'pages/Attendance/Attendance.styled'
import { colors } from 'styling/GlobalStyles'

// checked, onCheck
export const CircleButton = ({
  orange,
  checked,
  onClick,
}: {
  orange?: boolean
  checked: boolean
  onClick?: (e) => void
}) => {
  return (
    <Circle orange={orange} onClick={onClick}>
      <CheckBox checked={checked} />
    </Circle>
  )
}


interface CheckBoxProps {
  checked?: boolean
}
export const CheckBox = styled.div<CheckBoxProps>`
  background: ${(props) => {
    return props.checked ? `${props.theme.colorOrange}` : 'none'
  }};

  transition: all 0.2s linear;

  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
`

interface CircleProps {
  orange?: boolean
}
export const Circle = styled.div<CircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 1rem;
  min-height: 1rem;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid ${(props) => (props.orange ? props.theme.colorOrange : props.theme.colorGray)};
`

export const AddShiftInputs = styled.div`
  display: flex;
  gap: 1rem;
  width: 70%;
  align-items: end;
  
  @media (max-width: 500px) {
    flex-direction: column;
    width: 100%;
  
  }

`

export const ShiftsAssistantChatContainer = styled.div<{ empty: boolean }>`
  ${props => props.theme.container};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  ${props => props.empty ? 'height: 0; opacity:0;' : 'height: 90% ;opacity:1;'}
  min-height: 0;
  padding: 1rem;
  transition: .2s ease;
`


export const ShiftsAssistantChatInput = styled.div`
 width: 100%;
 padding: 1rem;
 border-radius: 10px;
 display: flex;
 align-items: center;
 gap: 1rem;

 ${props => props.theme.content};
 height: 10%;
 input{
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background-color: transparent;
  color: ${props => props.theme.textColor};
  font-size: 1rem;
  padding-left: 0.5rem;
 }
`

export const ChatLoader = styled.div`
   width: 20px;
    height: 20px;
    border: 2px solid #ccc; /* svetlosiva */
    border-top: 4px solid #555; /* tamnija siva za animaciju */
    border-radius: 50%;
    animation: spin 1.3s linear infinite;

      @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

`

export const ScheduleWeeklyCard = styled(AttendanceWeeklyCard)`

  height: 50px;
  

`

export const ScheduleOptionsWrapper = styled(AttendanceOptionsWrapper)`
  
`

export const ScheduleOption = styled(AttendanceOption)``

export const ScheduleMonthlyCard = styled(AttendanceMonthlyCard)``

export const AiShiftsWrapper = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
`
export const ScheduleNavigation = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 1060px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 0.75rem;

    > *:nth-child(2) {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
`

export const ShiftIconSelectBox = styled.div<{ active?: boolean }>`
  
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${props => props.theme.colorSurface1};
  border: 1px solid ${props => props.active ? '#ff9900' : props.theme.colorDividerDefault};

  &::hover{
    background-color:#FF99004D !important ; 
  }

`